export default {
  data() {
    return {
      showModalYt: false,
      modalYtId: null
    }
  },
  methods: {
    onModalYT(ytid) {
      this.modalYtId = ytid
      this.showModalYt = true
    },
    onCloseModalYT() {
      this.modalYtId = null
      this.showModalYt = false
    }
  }
}
